var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA70lEQVRYw+3WvQ7BUBiH8WdqwiZGpg7ifiTMEjchkXTUSQxcAjt3wX20EwmLhMFr8dEmpOejJ0TO/92fX9LhAH5+mQWMSUkZE7gBYuR+sRsgeQKJG0AyV/pChjlgSFhevM06F3/cilYZ+QGXt3lBONO3zY8+xl8fy2JdroXAlY5pvs6+MC8IO2pmwFQpLwgTk3yVozJwoKIP9JTzgtDVB+ZawEwf2GoBG5unTeUMnr+TFnCyeztVzgMe8MDvAZE2ELnNaxFmeWXCPK9IiOV9H/jfJba/wUVb5oBF+UAz8091R8PFR2qyJCVl4Sbv52o3tNXDE8TTiOMAAAAASUVORK5CYII="
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "planning_blck",
    "data-name": "planning blck",
    width: 33,
    height: 33,
    fill: "url(#pattern)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6ae5eaded7654a4b304664ac96b3c496.svg";
export { ForwardRef as ReactComponent };